module.exports = __webpack_public_path__ + "static/img/eboard-factory1.4ea6d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eboard-factory1.png
// module id = 6YSH
// module chunks = 1